<template>
  <Attivazioni v-if="hasAttivazioni" :slug="slug"/>
  <ProductPage v-else :slug="slug"/>
</template>

<script>
import { defineComponent, useRoute } from "@nuxtjs/composition-api";
import ProductPage from '~/pages/Product/index.vue';
import Attivazioni from '~/pages/Attivazioni/index.vue';

export default defineComponent({
  layout: 'product',
  components: {
    ProductPage,
    Attivazioni
  },
  setup() {
    const route = useRoute();
    const slug = route.value.params.slug;

    const hasAttivazioni =slug && slug.toLowerCase().includes('attivazioni');

    return {
      slug,
      hasAttivazioni
    };
  },
});
</script>
